import React, { useState } from "react";
import CheckIcon from '/Images/cekidot.svg'; // Checklist icon
import DeployImage from "/Images/custodyassetsnew2.svg"; // Gambar deployment
import { useMediaQuery } from "@mui/material"; // Import media query hook

const DeploymentSection = () => {
  // State untuk mengontrol tab aktif
  const [activeTab, setActiveTab] = useState("Security");
  const isMobile = useMediaQuery("(max-width: 767px)"); // Cek layar mobile

  const styles = {
    section: {
      padding: isMobile ? "50px 20px" : "100px", // Kurangi padding pada mobile
      textAlign: isMobile ? "center" : "left", // Center text untuk mobile
      position: "relative", // Set relative positioning for the container

    },
    container: {
      display: "flex",
      flexDirection: isMobile ? "column-reverse" : "row", // Column-reverse pada mobile untuk menempatkan gambar di atas
      justifyContent: "space-between",
      alignItems: "center",
    },
    leftSection: {
      width: isMobile ? "100%" : "50%", // Full width pada mobile
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: isMobile ? "center" : "flex-start", // Center alignment pada mobile
      textAlign: isMobile ? "center" : "left", // Center text pada mobile
      marginBottom: isMobile ? "20px" : "0", // Margin bawah pada mobile
    },
    title: {
      fontSize: isMobile ? "30px" : "40px", // Ukuran font lebih kecil pada mobile
      background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      fontWeight: "bold",
      marginBottom: "30px",
    },
    buttonContainer: {
      display: "flex",
      gap: isMobile? "2px":"10px", // Kurangi gap antara tombol pada mobile
      marginBottom: "30px",
      flexWrap: isMobile ? "wrap" : "nowrap", // Bungkus tombol pada mobile
      justifyContent: "center", // Pusatkan tombol pada mobile
    },
    button: {
      padding: "10px 20px",
      borderRadius: "20px",
      border: "none",
      cursor: "pointer",
      fontSize: isMobile? "0.875rem" : "1rem",
      fontWeight: "bold",
      color: "#214D73",
      backgroundColor: "#E0DCD9",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center", // Pusatkan teks dalam tombol
    },
    activeButton: {
      backgroundColor: "#2D669B",
      color: "#F4E37B",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    },
    inactiveButton: {
      backgroundColor: "#E0DCD9",
      color: "#214D73",
    },
    content: {
      width: "100%",
      maxWidth: isMobile ? "100%" : "600px",
      textAlign: "left",
      minHeight: "350px", // Set a minimum height for consistency
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    heading: {
      color: "#2D669B",
      fontSize: isMobile ? "18px" : "30px", // Ukuran font lebih kecil pada mobile
      fontWeight: "600",
      marginBottom: "20px",
      width: isMobile? "auto" : "496px",
       wordWrap: "break-word",
    },
    listItem: {
      display: "flex",
      alignItems: "flex-start", // Rata kiri
      marginBottom: "10px",
      color: "#6D6D6D",
      fontSize: isMobile? "0.875rem": "1rem",
      textAlign: "justify", // Pastikan teks selalu rata kiri
      width: isMobile? "auto":"463px"
      
    },
    listIcon: {
      width: "20px",
      height: "20px",
      marginRight: "10px",
      alignSelf: "flex-start", // Ratakan ikon ke atas
    },
    imageContainer: {
      width: isMobile ? "100%" : "45%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    image: {
      width: isMobile ? "80%" : "574px",
      maxWidth: isMobile ? "400px" : "574px",
      borderRadius: "10px",
      marginBottom: isMobile? "20px" : "0",
    },
  };

  return (
    <div style={styles.section}>
      {/* Judul Utama Section */}
      <div style={styles.title}>Custody Features</div>

      {/* Kontainer Utama */}
      <div style={styles.container}>
        {/* Left Section for Text and Buttons */}
        <div style={styles.leftSection}>
          {/* Button Navigation */}
          <div style={styles.buttonContainer}>
            {["Security", "Banking-grade", "Scalability"].map((tab) => (
              <button
                key={tab}
                style={{
                  ...styles.button,
                  ...(activeTab === tab ? styles.activeButton : styles.inactiveButton),
                }}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          <div style={styles.content}>
            {activeTab === "Security" && (
              <>
                <h2 style={styles.heading}>
                  Advanced Signature Mechanism & Defense In-depth
                </h2>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>FIPS Level 3 Hardware Security Module (HSM) strengthened with Tennet technology</span>
                </div>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>State-of-the-art configurable TSS and MPC algorithms strengthened with Tennet technology</span>
                </div>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>Advanced approval workflow: no limits on workflows and target operating model</span>
                </div>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>Full transparency: source code audit available</span>
                </div>
              </>
            )}

            {activeTab === "Banking-grade" && (
              <>
                <h2 style={styles.heading}>
                A Multi-layer Framework
                to Banking Grade Custody
                </h2>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>Risk management, compliance, AML and fraud detection</span>
                </div>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>Easily integrated with any core banking system, in production with ca. 10 of them: API-files, SWIFT, dedicated connectors</span>
                </div>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>Treasury and consolidated reporting including vostro positions</span>
                </div>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>Multi-tenant: have several BUs, booking centers on the same infrastructure</span>
                </div>
              </>
            )}

            {activeTab === "Scalability" && (
              <>
                <h2 style={styles.heading}>
                Architecture Built to Scale Horizontally and Vertically
                </h2>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>Micro-service architecture implementing best practices</span>
                </div>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>High Capacity: no limits on addresses and wallets</span>
                </div>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>Reliable broadcasting algorithms and nonce management</span>
                </div>
                <div style={styles.listItem}>
                  <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                  <span>Advanced transactions management: embedded batch validations and programmable wallet behavior</span>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Kontainer untuk gambar di sebelah kanan */}
        <div style={styles.imageContainer}>
          <img src={DeployImage} alt="Deployment" style={styles.image} />
        </div>
      </div>
    </div>
  );
};

export default DeploymentSection;
